import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { Report, TonnageDisclaimer, Progress } from "../../../shared";
import { Fragment } from "react";
import queryString from "query-string";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import "./CustomModal.css";

const schema = yup.object().shape(
  {
    fromDate: yup.string(),
    toDate: yup.string(),
    shipYear: yup.string(),
    transitDays: yup.string(),
    transporterOrder: yup.string(),
    interfaceId: yup.string().when(["interfaceType"], {
      is: (interfaceType) => interfaceType,
      then: yup.string().required("Interface Type requires an Interface ID Number."),
    }),
    interfaceType: yup.string(),
    wasteCd: yup.string(),
    methCode: yup.string(),
    city: yup.string(),
    county: yup.string(),
    cupa: yup.string(),
    epaId: yup.string().when(["manifestId"], {
      is: (manifestId) => !manifestId,
      then: yup.string().required("One of these fields is required."),
    }),
    manifestId: yup.string().when(["epaId"], {
      is: (epaId) => !epaId,
      then: yup.string().required("One of these fields is required."),
    }),
  },
  [
    ["manifestId", "epaId"],
    ["epaId", "manifestId"],
  ]
);

const cancelToken = axios.CancelToken;
let cancelBulkDownload;

function FindManifestsReport() {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    manifestId: "",
    epaId: params && params.epaId ? params.epaId : "",
    entityType: params && params.entityType ? params.entityType : "",
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
    shipYear: params && params.shipYear ? params.shipYear : "",
    transitDays: params && params.transitDays ? params.transitDays : "",
    wasteCd: params && params.wasteCd ? params.wasteCd : "",
    methCode: params && params.methCode ? params.methCode : "",
    county: params && params.county ? params.county : "",
    city: params && params.city ? params.city : "",
    cupa: params && params.cupa ? params.cupa : "",
    interfaceId: params && params.interfaceId ? params.interfaceId : "",
    interfaceType: params && params.interfaceType ? params.interfaceType : "",
    transporterOrder: params && params.transporterOrder ? params.transporterOrder : "",
    manifestsNoDataShow: params && params.manifestsNoDataShow ? params.manifestsNoDataShow : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Find Manifests");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/manifests/epaid"
  );
  const [rowDataCount, setRowDataCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [DLModalShow, setDLModalShow] = useState(false);
  const [alertModalS, setAlertModalShow] = useState(false);
  const [formDataRef, setFormDataRef] = useState([]);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [value, setValue] = useState(
    Math.round(Math.random() * (44 - 20)) + 20
  );
  const DLModalClose = () => setDLModalShow(false);
  const alertModalClose = () => setAlertModalShow(false);

  const formConfig = [
    {
      name: "manifestId",
      config: {
        col: "md",
        colWidth: "5",
        label: 
          <lable>Manifest Number<i className={`ca-gov-icon-question-line ml-2`}/></lable>
          ,
        placeholder: "",
        type: "text",
        info: "To search for multiple manifest numbers, enter a space after each manifest number. You may enter a maximum of 100 manifest numbers.",
      },
    },
    {
      name: "epaId",
      config: {
        col: "md",
        colWidth: "3",
        label: "ID Number",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "entityType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Entity Type",
        placeholder: "Select an Entity Type",
        type: "select3",
        data: [
          { label: "Generator", value: "Generator" },
          { label: "Transporter 1", value: "Transporter1" },
          { label: "Transporter 2", value: "Transporter2" },
          { label: "TSDF", value: "TSDF" },
        ],
      },
    },
    {
      name: "interfaceId",
      config: {
        col: "md",
        colWidth: "2",
        label: "Interface ID Number",
        info: "Enter an ID Number to find manifests where both the original ID Number and this ID Number are listed on the same manifests",
        type: "text",
        advanced: true,
      },
    },
    {
      name: "interfaceType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Interface Type",
        info: "Specify the entity type of the Interfaced ID Number.",
        placeholder: "Select a Interface Type",
        type: "select3",
        data: [
          { label: "Generator", value: "generator" },
          { label: "Transporter", value: "transporter" },
          { label: "TSDF", value: "tsdf" },
          { label: "ALT. TSDF", value: "alt tsdf" },
        ],
        advanced: true,
      },
    },
    {
      name: "transporterOrder",
      config: {
        col: "md",
        colWidth: "2",
        label: "Transporter Order",
        info: "The order the transporter appeared on a manifest, i.e., Transporter 1, Transporter 2.",
        type: "text",
        advanced: true,
      },
    },
    {
      name: "city",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "City",
        placeholder: "Select a City",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/cities",
        hasApi: true,
        advanced: true,
      },
    },
    {
      name: "county",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "County",
        placeholder: "Select a County",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
        advanced: true,
      },
    },
    {
      name: "wasteCd",
      config: {
        col: "md",
        colWidth: "3",
        label: "Waste Code",
        placeholder: "",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/wastecodes/all",
        hasApi: true,
        advanced: true,
        customStyles: {
          menu: (base) => ({
            ...base,
            width: "700px",
          }),
        },
      },
    },
    {
      name: "methCode",
      config: {
        col: "md",
        colWidth: "3",
        label: "Method Code",
        placeholder: "",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/method-codes",
        hasApi: true,
        advanced: true,
      },
    },
    {
      name: "cupa",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "CUPA",
        placeholder: "Select a CUPA",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/cupas",
        hasApi: true,
        advanced: true,
      },
    },
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Ship Year",
        placeholder: "Select a Year",
        type: "year",
      },
    },
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "manifestsNoDataShow",
      config: {
        col: "md",
        colWidth: "3",
        label: "Show Manifests Missing Data",
        placeholder: "",
        type: "select3",
        info: "Manifests missing data can only be viewed when searching by ID Number.",
        data: [
          { label: "Yes", value: "y" },
          { label: "No", value: "n" },
          { label: "Only", value: "o" },
        ],
        hide: user.isAuth === false ? true : false,
        advanced: true,
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "Manifest_Number",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/manifest/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Generator",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Transporter_1",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Transporter_2",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Additional_Transporters",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "TSDF",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "ALT_TSDF",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  const bulkDownlaodManifest = async (formData) => {
    if (rowDataCount > 500) {
      setAlertModalShow(true);
    } else {
      setFormDataRef(formData);
      setDLModalShow(true);
    }
  };

  const exportManData = async (formData) => {
    let qs = queryString.stringify(formData);
    await axios({
      url: `/api/v1/hwts/search/manifest/csv?${qs}`,
      method: "GET",
      responseType: "blob", // important
    })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        let filename = `ManifestDataRpt_${new Date().toLocaleDateString(
          "en-US"
        )}.csv`;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        //setIsLoading(false);
      })
      .catch((err) => {
        //setIsLoading(false);
        alert(err);
      });
  };

  const customButton = [
    {
      label: "Download Manifests",
      onClick: bulkDownlaodManifest,
    },
    {
      label: "Export Manifest Detail",
      onClick: exportManData,
    },
  ];

  const startDownlaoding = async () => {
    setIsLoading(true);
    let qs = queryString.stringify(formDataRef);
    var epa_ID = formDataRef.epaId.trim();
    var manifest_ID = formDataRef.manifestId.trim();

    await axios
      .get(`/api/v1/hwts/manifest-images/bulk-download?${qs}`, {
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 70) {
            setProgressPercentage(percentCompleted);
          }
        },
        responseType: "blob",
        cancelToken: new cancelToken(function executor(c) {
          cancelBulkDownload = c;
        }),
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        const fileName = epa_ID === "" ? manifest_ID : epa_ID;
        link.href = url;
        link.setAttribute("download", fileName + ".zip");
        document.body.appendChild(link);
        link.click();
        setIsLoading(false);
        setDLModalShow(false);
      })

      .catch(function (thrown) {
        setIsLoading(false);
        if (axios.isCancel(thrown)) {
          alert("Download request has canceled");
          setDLModalShow(false);
        } else {
          if (thrown.response) {
            console.log(thrown.response.data);
            console.log(thrown.response.status);
            console.log(thrown.response.headers);
          } else if (thrown.request) {
            console.log(thrown.request);
          }
          alert(thrown);
        }
      });
  };
  const cancelDownload = () => {
    if (cancelBulkDownload) cancelBulkDownload();
  };

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "Find Manifests", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        customGridCells={customGridCells}
        searchOnInit={searchOnInit}
        customButton={customButton}
        setRowDataCount={setRowDataCount}
      //reportDescription={reportDescription}
      />

      <div className="container">
        <TonnageDisclaimer />

        <Modal
          show={DLModalShow}
          onHide={DLModalClose}
          backdrop="static"
          keyboard={false}
          className="modal"
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Manifest Image Export</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoading === true ? (
              <div className="DownloadMSG">
                Please wait...
                <Progress
                  percent={progressPercentage}
                  setProgressPercentage={setProgressPercentage}
                  value={value}
                  stop={false}
                  grid={false}
                />
              </div>
            ) : (
                "You may experience long download times when requesting images for manifests generated on or after June 30, 2018. This is due to manifest image extraction limitations of the e-Manifest system."
              )}
          </Modal.Body>
          <Modal.Footer>
            {isLoading === true ? (
              <Button variant="secondary" onClick={() => cancelDownload()}>
                Cancel
              </Button>
            ) : (
                <Button
                  variant="primary"
                  onClick={() => {
                    // setProgressPercentage(0);
                    startDownlaoding();
                  }}
                >
                  Ok
                </Button>
              )}
          </Modal.Footer>
        </Modal>

        <Modal
          show={alertModalS}
          onHide={alertModalClose}
          backdrop="static"
          keyboard={false}
          className="modal"
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Manifest Image Export</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Cannot download more than 500 manifest images at a time. Please
            limit your search by adjusting the Shipment Date criteria.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={alertModalClose}>
              close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Fragment>
  );
}

export default FindManifestsReport;
